import { StarIcon } from '@heroicons/react/24/solid'
import { useTranslation } from 'react-i18next'

const STARS = [0, 1, 2, 3, 4]
const TESTIMONIALS = ['t1', 't2', 't3']

export default function PaywallReviews() {
  const { t } = useTranslation()

  const stores = [
    {
      label: `App Store · ${t('pages.checkout.trust_element.appStoreRatingsCount')}`,
      rating: t('pages.checkout.trust_element.appStoreRating'),
    },
    {
      label: `Google Play · ${t('pages.checkout.trust_element.googlePlayRatingsCount')}`,
      rating: t('pages.checkout.trust_element.googlePlayRating'),
    },
  ]

  return (
    <div className="space-y-5">
      <h2 className="hw-heading">{t('pages.checkout.testimonials.heading')}</h2>

      <div className="grid grid-cols-2 gap-3">
        {stores.map((store) => (
          <div
            className="hw-card flex flex-col items-center gap-1 p-4"
            key={store.label}
          >
            <p className="text-hw-ink text-3xl font-extrabold">
              {store.rating}
            </p>

            <div className="flex">
              {STARS.map((star) => (
                <StarIcon className="text-hw-yellow h-4 w-4" key={star} />
              ))}
            </div>

            <p className="text-hw-muted text-center text-xs font-medium">
              {store.label}
            </p>
          </div>
        ))}
      </div>

      <div className="-mx-4 flex snap-x snap-mandatory gap-3 overflow-x-auto px-4 pb-2 [scrollbar-width:none] [&::-webkit-scrollbar]:hidden">
        {TESTIMONIALS.map((testimonial) => (
          <div
            className="hw-card w-[85%] shrink-0 snap-center p-4"
            key={testimonial}
          >
            <div className="flex items-center justify-between gap-2">
              <p className="text-hw-ink font-semibold">
                {t(`pages.checkout.testimonials.${testimonial}.author`)}
              </p>

              <div className="flex">
                {STARS.map((star) => (
                  <StarIcon className="text-hw-yellow h-4 w-4" key={star} />
                ))}
              </div>
            </div>

            <p className="text-hw-muted mt-0.5 text-xs">
              {t(`pages.checkout.testimonials.${testimonial}.detail`)}
            </p>

            <p className="text-hw-muted mt-2 text-sm leading-relaxed">
              {t(`pages.checkout.testimonials.${testimonial}.text`)}
            </p>
          </div>
        ))}
      </div>
    </div>
  )
}
